module.exports = __webpack_public_path__ + "static/media/cuisine-moleculaire.aca6a116.jpg";